import { useEffect, useRef, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, dataFormat, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { _ConsolidatePAC, _ConsolidatePACbycache } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { SelectBudgetTypes } from "../../../erp/cellEditor/AccountantConcept/SelectBudgetTypes";
import { SelectBudgetResource } from "../../select/SelectBudgetResource";
import { SelectBudgetSource } from "../../../admin/configuracion/BudgetSource/SelectBudgetSource";
import { SelectBudgetID } from "../../../admin/configuracion/BudgetID/SelectBudgetID";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { ExportExcelComponent } from "../../../theme/Component/ExportExcelComponent";
import { SelectBudgetType } from "../../../admin/configuracion/select/SelectBudgetType";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { DropDown } from "../../../theme/Component/DropDown";
import useModal, { MODAL_LG } from "../../../theme/Component/hooks/useModal";
import { ImportXLSX } from "../../../theme/Component/ImportXLSX";
import AutoChart from "../../../../core/graph/AutoChart";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { DetailEgress } from "./DetailEgress";
import { SelectMonths } from "../../select/SelectMonths";

export const ConsolidatePAC = () => {

    const ConsolidatePAC = useDataBean(_ConsolidatePAC);
    // const ConsolidatePACbycache = useDataBean(_ConsolidatePACbycache);
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [month, setMonth] = useState<number>(_single.getCurrentMonth());
    const [type, setType] = useState<number>(26);
    const [conso, setConso] = useState<any>({
        Year: _single.getCurrenYear(),
        Month: _single.getCurrentMonth()
    });

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);

    const [data, setData] = useState<any>({
        type: null,
    });

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalImport = useModal("Importar PAC", MODAL_LG);
    const [excel, setExel] = useState<any>([]);
    const modalGraph = useModal("Grafica", MODAL_LG);
    const modalConsolidate = useModal("Consolidar", MODAL_LG);
    const modalDetalle = useModal("Detalle", MODAL_LG);


    useEffect(() => {
        getLista()

    }, [])

    const getLista = () => {

        let filtro: any = {
            State: 1,
            YearPAC: year
        };
        if (data.IDBudgetType)
            filtro.IDBudgetType = data.IDBudgetType;
        if (data.IDBudgetResource)
            filtro.IDBudgetResource = data.IDBudgetResource;
        if (data.IDBudgetSource)
            filtro.IDBudgetSource = data.IDBudgetSource;
        if (data.BudgetIDStr)
            filtro.BudgetIDStr = data.BudgetIDStr;

        ConsolidatePAC.instance.getConsolidatePACRender(null, null, filtro).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp.List);
                    resp.List.forEach(element => {
                        element = getConsolidateMonth(element);

                    });

                }
            }
        )
    }

    const getConsolidateMonth = (element: any) => {
        let consolidado: any = {};
        try {
            consolidado = JSON.parse(element.DataBeanProperties.JsonClose ?? '{}');
            element.DataBeanProperties.JsonClose = consolidado;
            getResumeMonth(element, 0, element.DataBeanProperties.Month0, consolidado.Month0);
            getResumeMonth(element, 1, element.DataBeanProperties.Month1, consolidado.Month1);
            getResumeMonth(element, 2, element.DataBeanProperties.Month2, consolidado.Month2);
            getResumeMonth(element, 3, element.DataBeanProperties.Month3, consolidado.Month3);
            getResumeMonth(element, 4, element.DataBeanProperties.Month4, consolidado.Month4);
            getResumeMonth(element, 5, element.DataBeanProperties.Month5, consolidado.Month5);
            getResumeMonth(element, 6, element.DataBeanProperties.Month6, consolidado.Month6);
            getResumeMonth(element, 7, element.DataBeanProperties.Month7, consolidado.Month7);
            getResumeMonth(element, 8, element.DataBeanProperties.Month8, consolidado.Month8);
            getResumeMonth(element, 9, element.DataBeanProperties.Month9, consolidado.Month9);
            getResumeMonth(element, 10, element.DataBeanProperties.Month10, consolidado.Month10);
            getResumeMonth(element, 11, element.DataBeanProperties.Month11, consolidado.Month11);
        } catch (error) {

        }


        return consolidado;
    }

    const getResumeMonth = (element: any, index: number, value: number, consolidado: any) => {
        const pac = value ?? 0;
        const ob = consolidado?.OB ?? 0;
        const ce = consolidado?.CE ?? 0;
        const cenp = consolidado?.NPCE ?? 0;
        element.DataBeanProperties[`Month${index}OB`] = ob;
        element.DataBeanProperties[`Month${index}CE`] = ce;
        // element.DataBeanProperties[`Month${index}CE`] = ce + cenp;

        // return render;
    }

    // cambios para consolidado pac


    const create = () => {
        ConsolidatePAC.setBean({
            State: 1,
            YearPAC: year,
            IDBudgetType: data.IDBudgetType,
            BudgetIDStr: data.BudgetIDStr,
            IDBudgetResource: data.IDBudgetResource,
            IDBudgetSource: data.IDBudgetSource
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        ConsolidatePAC.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        ConsolidatePAC.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });


    }
    const importPac = () => {
        let b = ConsolidatePAC.bean;
        ConsolidatePAC.instance.importPAC(b.YearPAC, b.IDBudgetType, b.IDBudgetResource, b.IDBudgetSource, JSON.stringify(excel)).then(
            (resp: any) => {

                modalImport.close();
                getLista();

            }
        )
    }


    const head = [
        { title: 'ID', property: 'IDConsolidatePAC', visible: false, mask: MASK_NUMBER },
        { title: 'Vigencia', property: 'YearPAC', visible: false, mask: MASK_NUMBER },

        { title: 'Presupuesto', property: 'NameBudgetType', visible: true, mask: null },
        { title: 'Codigo', property: 'BudgetIDStr', visible: true, mask: null },
        { title: 'Rubro', property: 'NameBudget', visible: true, mask: null },

        { title: 'Recurso', property: 'NameBudgetResource', visible: true, mask: null },
        { title: 'Fuente', property: 'NameBudgetSource', visible: true, mask: null },

        // Enero
        { title: 'Ene. PAC', property: 'Month0', visible: true, mask: MASK_MONEY },
        { title: 'Ene. OB', property: 'Month0OB', visible: true, mask: MASK_MONEY },
        { title: 'Ene. CE', property: 'Month0CE', visible: true, mask: MASK_MONEY },
        // Febrero
        { title: 'Feb. PAC', property: 'Month1', visible: true, mask: MASK_MONEY },
        { title: 'Feb. OB', property: 'Month1OB', visible: true, mask: MASK_MONEY },
        { title: 'Feb. CE', property: 'Month1CE', visible: true, mask: MASK_MONEY },
        // Marzo
        { title: 'Mar. PAC', property: 'Month2', visible: true, mask: MASK_MONEY },
        { title: 'Mar. OB', property: 'Month2OB', visible: true, mask: MASK_MONEY },
        { title: 'Mar. CE', property: 'Month2CE', visible: true, mask: MASK_MONEY },
        // Abril
        { title: 'Abr. PAC', property: 'Month3', visible: true, mask: MASK_MONEY },
        { title: 'Abr. OB', property: 'Month3OB', visible: true, mask: MASK_MONEY },
        { title: 'Abr. CE', property: 'Month3CE', visible: true, mask: MASK_MONEY },
        // Mayo
        { title: 'May. PAC', property: 'Month4', visible: true, mask: MASK_MONEY },
        { title: 'May. OB', property: 'Month4OB', visible: true, mask: MASK_MONEY },
        { title: 'May. CE', property: 'Month4CE', visible: true, mask: MASK_MONEY },
        // Junio
        { title: 'Jun. PAC', property: 'Month5', visible: true, mask: MASK_MONEY },
        { title: 'Jun. OB', property: 'Month5OB', visible: true, mask: MASK_MONEY },
        { title: 'Jun. CE', property: 'Month5CE', visible: true, mask: MASK_MONEY },
        // Julio
        { title: 'Jul. PAC', property: 'Month6', visible: true, mask: MASK_MONEY },
        { title: 'Jul. OB', property: 'Month6OB', visible: true, mask: MASK_MONEY },
        { title: 'Jul. CE', property: 'Month6CE', visible: true, mask: MASK_MONEY },
        // Agosto
        { title: 'Ago. PAC', property: 'Month7', visible: true, mask: MASK_MONEY },
        { title: 'Ago. OB', property: 'Month7OB', visible: true, mask: MASK_MONEY },
        { title: 'Ago. CE', property: 'Month7CE', visible: true, mask: MASK_MONEY },
        // Septiembre
        { title: 'Sep. PAC', property: 'Month8', visible: true, mask: MASK_MONEY },
        { title: 'Sep. OB', property: 'Month8OB', visible: true, mask: MASK_MONEY },
        { title: 'Sep. CE', property: 'Month8CE', visible: true, mask: MASK_MONEY },
        // Octubre
        { title: 'Oct. PAC', property: 'Month9', visible: true, mask: MASK_MONEY },
        { title: 'Oct. OB', property: 'Month9OB', visible: true, mask: MASK_MONEY },
        { title: 'Oct. CE', property: 'Month9CE', visible: true, mask: MASK_MONEY },
        // Noviembre
        { title: 'Nov. PAC', property: 'Month10', visible: true, mask: MASK_MONEY },
        { title: 'Nov. OB', property: 'Month10OB', visible: true, mask: MASK_MONEY },
        { title: 'Nov. CE', property: 'Month10CE', visible: true, mask: MASK_MONEY },
        // Diciembre
        { title: 'Dic. PAC', property: 'Month11', visible: true, mask: MASK_MONEY },
        { title: 'Dic. OB', property: 'Month11OB', visible: true, mask: MASK_MONEY },
        { title: 'Dic. CE', property: 'Month11CE', visible: true, mask: MASK_MONEY },
    ]



    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create },
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Detalle PAC', icono: 'ri-edit-2-line', visible: true, evento: () => { modalDetalle.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [viewD, setViewD] = useState<boolean>(false);
    const [tipoP, setTipoP] = useState<any>();
    const [format, setFormat] = useState<boolean>(false);
    const li = useRef<any>();
    const co = useRef<any>();
    useEffect(() => {
        li.current = [
            {
                sheetName: 'Tipo Presupuesto',
                data: _single.trasformDataBeanToList(tipoP, "Value", "Property")
            }
        ];

        co.current = [
            { header: 'Nombre', key: 'nombre', type: 'string' },
            { header: 'Edad', key: 'edad', type: 'number' },
            { header: 'Fecha de Nacimiento', key: 'fechaNacimiento', type: 'date' }
        ];
        return () => { setFormat(false) }
    }, [format])

    const consolidateMonth = () => {
        ConsolidatePAC.instance.consolidatePACByMonth(conso.Year, conso.Month).then(
            (resp: any) => {

                modalConsolidate.close();
                toast.success("Mes Consolidado");
                getLista();
            }
        )
    }


    const actionsDropDown = [
        { id: 1, name: 'Importar Plan', permiso: null, activo: true },
        { id: 2, name: 'Reporte Gráfico', permiso: null, activo: true },
        { id: 3, name: 'Consolidar Mes', permiso: null, activo: true },

    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1) {
                            modalImport.open();
                        }
                        else if (e.id === 2) {
                            modalGraph.open();
                        }
                        else if (e.id === 3) {
                            modalConsolidate.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }


    return (
        <BasicPage titulo="Planeación PAC">
            <ExportExcelComponent lists={li.current} dataColumns={co.current} download={format} />
            <div className="row">
                <div className="row">
                    <div className="col-md-2">
                        <YearSelector value={year} onChange={(e) => { setYear(e) }} />
                    </div>
                    <div className="col-md-3">
                        <SelectBudgetTypes label="Tipo" idSelector={type} onChange={(e) => { setType(parseInt(e)) }} />
                    </div>
                    <div className="col-md-3">
                        <SelectBudgetType idType={type} idSelector={data.IDBudgetType} onChange={(e) => { setData({ ...data, "IDBudgetType": parseInt(e) }) }} />
                    </div>
                    <div className="col-md-3">
                        <SelectBudgetResource idSelector={data.IDBudgetResource} onChange={(e) => { setData({ ...data, "IDBudgetResource": e > 0 ? parseInt(e) : null }) }} />
                    </div>
                    <div className="col-md-3">
                        <SelectBudgetSource idSelector={data.IDBudgetSource} onChange={(e) => { setData({ ...data, "IDBudgetSource": e > 0 ? parseInt(e) : null }) }} />
                    </div>
                    <div className="col-md-4">
                        <SelectBudgetID jsonCode={data.BudgetIDStr} onChange={(e) => { setData({ ...data, "BudgetIDStr": e.JsonCode }) }} />
                    </div>
                    <div className="col-md-12 mt-4">
                        <BasicButton icon="" eventClick={getLista}>Buscar</BasicButton>
                    </div>

                </div>
                <div className="col-md-12">

                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={ConsolidatePAC.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} _exportFormat={setFormat}></BasicTable>

                    <Modal modal={modalDetalle.modal} updateModal={modalDetalle.setModal}>
                        <div className="row">
                            <div className="col-md-6">
                                <SelectMonths idSelector={month} onChange={(e) => { setMonth(e) }} />
                            </div>
                            <div className="col-md-12">
                                <DetailEgress
                                    year={year}
                                    month={month}
                                    budgetStr={ConsolidatePAC.bean.BudgetIDStr}
                                    budgettype={ConsolidatePAC.bean.IDBudgetType}
                                    budgetResource={ConsolidatePAC.bean.IDBudgetResource}
                                    budgetSource={ConsolidatePAC.bean.IDBudgetSource} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <SelectBudgetID label='Rubro' jsonCode={ConsolidatePAC.bean.BudgetIDStr} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'BudgetIDStr': e.JsonCode }) }} />
                                </div>
                                <div className="col-md-6">
                                    <YearSelector value={ConsolidatePAC.bean.YearPAC} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'YearPAC': e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <SelectBudgetTypes label="Tipo" idSelector={type} onChange={(e) => { setType(parseInt(e)) }} />
                                </div>
                                <div className="col-md-6">
                                    <SelectBudgetType label="Presupuesto" idType={type} idSelector={ConsolidatePAC.bean.IDBudgetType} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'IDBudgetType': e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <SelectBudgetResource label='Recurso' idSelector={ConsolidatePAC.bean.IDBudgetResource} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'IDBudgetResource': e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <SelectBudgetSource label='Fuente' idSelector={ConsolidatePAC.bean.IDBudgetSource} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'IDBudgetSource': e }) }} />
                                </div>
                                <hr className="mt-4" />
                                <div className="col-md-3">
                                    <InputMoney _label='Valor Enero' _value={ConsolidatePAC.bean.Month0} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'Month0': e }) }} />
                                </div>
                                <div className="col-md-3">
                                    <InputMoney _label='Valor Febrero' _value={ConsolidatePAC.bean.Month1} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'Month1': e }) }} />
                                </div>
                                <div className="col-md-3">
                                    <InputMoney _label='Valor Marzo' _value={ConsolidatePAC.bean.Month2} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'Month2': e }) }} />
                                </div>
                                <div className="col-md-3">
                                    <InputMoney _label='Valor Abril' _value={ConsolidatePAC.bean.Month3} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'Month3': e }) }} />
                                </div>
                                <div className="col-md-3">
                                    <InputMoney _label='Valor Mayo' _value={ConsolidatePAC.bean.Month4} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'Month4': e }) }} />
                                </div>
                                <div className="col-md-3">
                                    <InputMoney _label='Valor Junio' _value={ConsolidatePAC.bean.Month5} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'Month5': e }) }} />
                                </div>
                                <div className="col-md-3">
                                    <InputMoney _label='Valor Julio' _value={ConsolidatePAC.bean.Month6} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'Month6': e }) }} />
                                </div>
                                <div className="col-md-3">
                                    <InputMoney _label='Valor Agosto' _value={ConsolidatePAC.bean.Month7} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'Month7': e }) }} />
                                </div>
                                <div className="col-md-3">
                                    <InputMoney _label='Valor Septiembre' _value={ConsolidatePAC.bean.Month8} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'Month8': e }) }} />
                                </div>
                                <div className="col-md-3">
                                    <InputMoney _label='Valor Octubre' _value={ConsolidatePAC.bean.Month9} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'Month9': e }) }} />
                                </div>
                                <div className="col-md-3">
                                    <InputMoney _label='Valor Noviembre' _value={ConsolidatePAC.bean.Month10} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'Month10': e }) }} />
                                </div>
                                <div className="col-md-3">
                                    <InputMoney _label='Valor Diciembre' _value={ConsolidatePAC.bean.Month11} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'Month11': e }) }} />
                                </div>
                            </div>

                        </>
                    </Modal>

                    <Modal modal={modalImport.modal} updateModal={modalImport.setModal} eventModal={importPac} onSubmitLabel="Importar">
                        <div className="row">

                            <div className="col-md-6">
                                <YearSelector value={ConsolidatePAC.bean.YearPAC} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'YearPAC': e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetTypes label="Tipo" idSelector={type} onChange={(e) => { setType(parseInt(e)) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetType label="Presupuesto" idType={type} idSelector={ConsolidatePAC.bean.IDBudgetType} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'IDBudgetType': e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetResource label='Recurso' idSelector={ConsolidatePAC.bean.IDBudgetResource} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'IDBudgetResource': e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetSource label='Fuente' idSelector={ConsolidatePAC.bean.IDBudgetSource} onChange={(e: any) => { ConsolidatePAC.setBean({ ...ConsolidatePAC.bean, 'IDBudgetSource': e }) }} />
                            </div>
                            <div className="col-md-6">
                                <ImportXLSX label="Plano PAC" lodaData={setExel} />
                            </div>

                        </div>
                    </Modal>
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart
                            data={lista}
                            head={head}
                            useIndexAsXLabel={true}
                            xOptions={['BudgetIDStr', 'NameBudget', 'NameBudgetResource', 'NameBudgetSource']}
                            yOptions={[
                                'Month0', 'Month0OB', 'Month0CE',
                                'Month1', 'Month1OB', 'Month1CE',
                                'Month2', 'Month2OB', 'Month2CE',
                                'Month3', 'Month3OB', 'Month3CE',
                                'Month4', 'Month4OB', 'Month4CE',
                                'Month5', 'Month5OB', 'Month5CE',
                                'Month6', 'Month6OB', 'Month6CE',
                                'Month7', 'Month7OB', 'Month7CE',
                                'Month8', 'Month8OB', 'Month8CE',
                                'Month9', 'Month9OB', 'Month9CE',
                                'Month10', 'Month10OB', 'Month10CE',
                                'Month11', 'Month11OB', 'Month11CE',
                            ]}
                        />
                    </Modal>
                    <Modal modal={modalConsolidate.modal} updateModal={modalConsolidate.setModal} eventModal={consolidateMonth} onSubmitLabel="Consolidar">
                        <div className="row">
                            <div className="col-md-6">
                                <YearSelector value={conso.Year} onChange={(e) => { setConso({ ...conso, "Year": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <MonthConstantsEditor name="mes" label="Mes" idSelect={conso.Month} onChange={(e) => { setConso({ ...conso, "Month": e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}